import { Chip } from '@ds';
import { OrganTypeBadge } from '@ui';
import { OrganType } from '@/api/apis/case';

type RoleChipProps = {
  label: string;
  organs: OrganType[];
  organBadgeProps?: {
    bgTone?: 'bg40' | 'bg50' | 'bg60';
    showBackground?: boolean;
  };
};

export const RoleChip = ({ label, organs, organBadgeProps }: RoleChipProps) => (
  <Chip className="leading-none bg-base-60" classNames={{ content: 'flex gap-1 items-center' }}>
    <div>{label}</div>
    {organs.map((organ) => (
      <OrganTypeBadge key={organ} organ={organ} size="sm" {...organBadgeProps} />
    ))}
  </Chip>
);
